export const NAME_FIELD_CONFIG: Record<
  string,
  {
    label: string;
    min: number;
    max: number;
    allowSpaces: boolean;
    pattern?: RegExp;
    patternMessage?: string;
  }
> = {
  name: {
    label: 'Name',
    min: 1,
    max: 50,
    allowSpaces: true,
  },
  first_name: {
    label: 'First Name',
    min: 1,
    max: 50,
    allowSpaces: false,
  },
  sponsor_name: {
    label: 'Sponsor Name',
    min: 1,
    // Matches the sponsor_details.sponsor_name column; HubSpot company names
    // such as "A.C. Jones High School (PRO - TX) (600534)" ran past the old 50.
    max: 255,
    allowSpaces: true,
    // Business names carry punctuation - dots and apostrophes in "A.C. Jone's
    // High School", parentheses in "(PRO - TX)", a comma before ", Inc" - and
    // partners routinely append the school year as "26-27" or "26/27".
    // Everything outside this set, including % and #, stays rejected.
    pattern: /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 &\-/.'(),]+$/,
    patternMessage:
      "Sponsor Name can only contain letters, numbers, spaces and & - / . ' ( ) ,",
  },
  last_name: {
    label: 'Last Name',
    min: 2,
    max: 50,
    allowSpaces: false,
  },
  main_contact: {
    label: 'Main Contact',
    min: 2,
    max: 50,
    allowSpaces: true,
  },
  title: {
    label: 'Title',
    min: 3,
    max: 50,
    allowSpaces: true,
  },
};
